module.exports = __webpack_public_path__ + "img/11.5355f8be.svg";